// Mirror-scene route view (taxgw-lcaj): each frame, after InterpolationSystem resolved the render poses, it hands every
// transport craft in the mirror to the TransportRouteLayer, which draws the craft's stored trip trimmed at its pose.
// A craft the layer holds no route for (idle, or another seat's) draws nothing. The war screen brackets the frame
// (begin/end), and end() drops the routes of crafts this system did not hand over.

import { Matcher, type Entity } from '@esengine/ecs-framework'
import { Owner, SimIdentity, TransportHull, type OwnerValue, type SimId } from '@taxwar/net'
import { PoseTrack, PresentationOrder, PresentationSystem } from '../../match/presentation'
import type { TransportRouteLayer } from './TransportRouteLayer'

export class TransportRouteSystem extends PresentationSystem {
  constructor(private readonly routes: TransportRouteLayer) {
    super(Matcher.all(TransportHull, Owner, SimIdentity, PoseTrack), PresentationOrder.entityViews)
  }

  protected override present(entities: readonly Entity[]): void {
    for (let i = 0; i < entities.length; i++) {
      const entity = entities[i] as Entity
      const simId = (entity.getComponent(SimIdentity) as SimIdentity).simId as SimId
      const owner = (entity.getComponent(Owner) as Owner).player as OwnerValue
      const pose = entity.getComponent(PoseTrack) as PoseTrack
      this.routes.draw(simId, owner, pose.lat, pose.lon)
    }
  }
}
